export const LIST = "LUCKY_SPIN_GIFT_ASSIGN_LIST";
export const UPDATE_STATUS = "LUCKY_SPIN_GIFT_ASSIGN_UPDATE";
export const DELETE = "LUCKY_SPIN_GIFT_ASSIGN_DELETE";
export const STORE = "LUCKY_SPIN_GIFT_ASSIGN_STORE";
export const GET_MEMBER = "LUCKY_SPIN_GIFT_ASSIGN_GET_MEMBER";